module.exports = __webpack_public_path__ + "static/img/top_bg.de61bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/top_bg.png
// module id = Sa5p
// module chunks = 6